import { type FC } from "react";

import { Card, type GridCard } from "widgets";

import { type AttributeValue, type Sample } from "../../../graphql.js";
import AttributeValuesCardRows from "./AttributeValuesCardRows.js";

export interface ISampleValuesCardProps extends GridCard {
  sample: Sample;
  name: string;
  title?: string;
  values: AttributeValue[];
}

const SampleValuesCard: FC<ISampleValuesCardProps> = (props) => {
  const sample: Sample = props.sample;
  if (!sample || props.values.length === 0) {
    return null;
  }

  return (
    <Card key="sample-parents-card" title={props.title ?? "Sample Values"} id={"sample-parents-card"}>
      <AttributeValuesCardRows values={props.values} />
    </Card>
  );
};

export { SampleValuesCard };
